import type { Cooperation } from '../types';

interface CooperationSectionProps {
  data: Cooperation;
}

export default function CooperationSection({ data }: CooperationSectionProps) {
  const { count = 0, logos = [] } = data || {};

  const hasContent = count > 0 || (logos && logos.length > 0);

  if (!hasContent) {
    return null;
  }

  const displayCount = count > 0 ? `${count}+` : '';

  return (
    <div>
      {/* 标题区域 */}
      <div className="px-4 py-3 border-b border-gray-100 flex items-center">
        <div className="flex items-center gap-2">
          <h3 className="text-base font-bold text-gray-900">合作情况</h3>
          <p className="text-xs text-gray-400 tracking-widest ml-1">COOPERATION CASES</p>
        </div>
      </div>

      {/* 内容区域 */}
      <div className="px-4 pb-4 mt-4">
        {/* 描述和数量 */}
        <div className="flex items-start justify-between mb-4">
          <div>
            <p className="text-sm text-gray-700 font-medium">部分合作伙伴</p>
            <p className="text-xs text-gray-500 mt-1">感谢与我们一起并肩作战的伙伴们！</p>
          </div>
          {displayCount && (
            <div className="text-right">
              <span className="text-3xl font-bold text-[#1c5bff]">{count > 30 ? '30+' : count + '+'}</span>
            </div>
          )}
        </div>

        {/* Logo 网格 */}
        {logos.length > 0 && (
          <div className="grid grid-cols-3 gap-3">
            {logos.slice(0, 5).map((logo, idx) => (
              <div
                key={idx}
                className="aspect-[3/2] bg-gray-50 rounded-lg flex items-center justify-center overflow-hidden border border-gray-100"
              >
                {logo ? (
                  <img
                    src={logo}
                    alt={`partner-${idx + 1}`}
                    className="max-w-full max-h-full object-contain p-2"
                  />
                ) : (
                  <span className="text-2xl text-gray-300">...</span>
                )}
              </div>
            ))}
            {logos.length > 5 && (
              <div className="aspect-[3/2] bg-gray-50 rounded-lg flex items-center justify-center border border-gray-100">
                <span className="text-2xl text-gray-400">...</span>
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
}
